module.exports = __webpack_public_path__ + "img/jiaotong-1.735ee843.jpg";